export const PartnerStatus = {
    PROVIDER_REQUESTED: 0,
    AGENCY_REQUESTED: 1,
    ACCEPTED: 2
}